import {v4 as uuid } from 'uuid';
import isEmpty from 'lodash/isEmpty';

import {
    removeDuplicateStrings,
    arrayIncludes,
} from '../../../../commons/utils/arrays';
import {
    getSchedulesAPI,
    getSchedulesWithIdsAPI,
} from './api';

function formatIdsForQueryParams (ids) {
    if (!ids || !ids.length) {
      return '';
    }
    const commaSeparatedIds = ids.join(',');
    return commaSeparatedIds; // encodeURIComponent(commaSeparatedIds);
}

function formatReferenceAsQueryParams (refs) {
    if (!refs || !refs.length) {
        return '';
    }
    const query = refs.join(',');
    return encodeURIComponent(query);
}

async function getSchedules () {
    const env = this.env;
    const appStore = this.env.appStore;
    const apiKey = appStore.widgetSettings.apikey;

    // NOTE: The CountryCode in the PATH is based on the Location API. Not from the Browsers Language..
    const path = appStore.params.category || '';

    /*
    let locale = appStore.locale;
    if ( appStore.widget?.language && appStore.widget?.language !== 'auto') {
        locale = appStore.widget?.language;
    }
    */

    console.log('getSchedule() Path -> ', path);
    console.log('getSchedules(): ', env.page);

    let res = {};
    let byCategories = false;

    if (!isEmpty(appStore.params.category)) {
        byCategories = true;
        this.categoryFromPath = true;
    }
    
    if (isEmpty(env.page?.params?.scheduleIds) && isEmpty(env.page?.params?.calendarIds) && isEmpty(env.page?.params?.calendar_reference)) {
        res = await getSchedulesAPI({
            apiKey,
            widgetId: appStore.widget.id,
            traceId: env.traceId,
            store: this,
            path,
        });
    } else {
        console.log('getSchedules() for calendar reference..', env.page?.params?.calendar_reference);
        if (!isEmpty(env.page?.params?.calendar_reference)) {
            console.log('getSchedules() for calendar reference..', env.page?.params?.calendar_reference);
            const calRef = formatReferenceAsQueryParams(env.page?.params?.calendar_reference);
            console.log('Cal Ref: ', calRef);
            res = await getSchedulesWithIdsAPI({
                apiKey,
                calIds: calRef,
                traceId: env.traceId,
                store: this,
                path,
            });
        } else if (!isEmpty(env.page?.params?.scheduleIds)) {
            // handle event displays IDS
            const calIds = formatReferenceAsQueryParams(env.page?.params?.scheduleIds);
            console.log('getSchedules(): Schedule IDS: ', calIds);
            res = await getSchedulesWithIdsAPI({
                apiKey,
                calIds,
                traceId: env.traceId,
                store: this,
                path,
            });

        } else {
            const calIds = formatIdsForQueryParams(env.page?.params?.calendarIds);
            console.log('getSchedules(): CalendarIDS: ', calIds);
            res = await getSchedulesWithIdsAPI({
                apiKey,
                calIds,
                traceId: env.traceId,
                store: this,
                path,
            });
        }
    }

    console.log('getSchedules(): Res.data ', res.data);
    if (isEmpty(res.data)) {
        this.schedulesError = true;
        return;
    }

     // For calendar reference or handling a single schedule..
    if (res.data.calendars === undefined) {
        // returns a single schedule
        this.schedules = [
            res.data,
        ];
        this.allScheduleIds = [this.schedules[0].id];
        this.categories = [];
        this.byCategories = false;
        this.observed.schedules = uuid();
        return;
    }

    if (res.data.count === 0 ||
        (Array.isArray(res.data.calendars) &&
        isEmpty(res.data.calendars)) ) {
        this.schedules = [];
        this.categories = [];
        this.byCategories = false;
        this.observed.schedules = uuid();
        return;
    }

    this.schedulesSources = res.data.calendars;
    this.allScheduleIds = this.schedulesSources.map((item) => item.id);
    console.log('getSchedules() All Schedule Ids: ', this.allScheduleIds);
    if (res.data?.categCalendars) {
        this.byCategories = true;
        this.categories = flattenCategories(res.data.categCalendars);
        if (this.categories.length <= 1) {
            this.byCategories = false;
        }
        this.selectSchedulesByCategory(this.categories[0]);
    } else if (!isEmpty(res.data?.data)) {
        this.byCategories = byCategories;
        this.schedules = res.data.calendars;
        // const npath = path.replaceAll('{{ECAL_USER_LANGUAGECODE}}', locale);
        this.categories = flattenDataCategory(res.data.data, this.schedulesSources, path);

        if (this.categories.length <= 1) {
            this.byCategories = false;
        }
        this.selectSchedulesByCategoryData(this.categories[0]);
    } else {
        this.schedules = res.data.calendars;
        this.categories = [];
        this.byCategories = byCategories;
        this.observed.schedules = uuid();
    } 
}

function flattenCategories (catSource) {
    const catKeys = Object.keys(catSource);
    const categories = catKeys.map((key) => {
        const category = catSource[key];
        let label = key;
        if (label.indexOf('/')  !== -1) {
            label = label.split('/')[1];
        }
        return {
            label,
            value: category.categoryIds[0],
            scheduleIds: category.calendarIds,
            categoryIds: category.categoryIds,
        };
    })
    return categories;
}

function fixCategoryPathKeys (path, catSource) {
    const paths = decodeURIComponent(path).split(',');
    const langCodeMeta = '{{ECAL_USER_LANGUAGECODE}}';
    // console.log('fixCategoryPathKeys() ', paths);
    // console.log('catSource: ', catSource);
    const catPathKeys = Object.keys(catSource);
   
    let fixedPaths = paths.map((v) => {
        if (v.indexOf(langCodeMeta) !== -1) {
            const pathParts = v.split(langCodeMeta);
            let newV = v;
            if (pathParts.length <= 0) {
                return newV;
            }
            
            catPathKeys.forEach((key) => {
            if (key.startsWith(pathParts[0]) && key.endsWith(pathParts[1])) {
                // capture the key from the API response and used it as part of the filtered Paths
                newV = key;
            }
            });
            return newV;
        }
        return v.trim();
    });

    fixedPaths = fixedPaths.filter((v) => {
        return (v !== '');
    });

    return fixedPaths;
}

function flattenDataCategory (catSource, schedulesSources, path) {
    console.log('flattenDataCategory() ', path);
    const fixedPaths = fixCategoryPathKeys(path, catSource);

    const dataCategories = fixedPaths.map((key) => {
        const tkey = key.trim();
        const schedules = catSource[tkey];
        for (let i = 0; i < schedules.length; i++) {
            const sched = schedules[i];
            if (isEmpty(sched.logo)) {
                sched.logo = sched.LogoUrl;
            }
        }
        /*
        const categoryIds = getAllCategoryIds(catItems);
        const schedules = getSchedulesForCatIds(categoryIds, schedulesSources);
        */
        
        // console.log('schedules(): ', schedules);
        let k = key;
        if (key.indexOf('/') !== -1) {
            const items = key.split('/');
            k = items[items.length-1];
        }
        return {
            label: k,
            value: key,
            // categoryIds,
            schedules,
        };
    });

    const finalData = [];
    for (let i = 0; i < dataCategories.length; i++) {
        const cat = dataCategories[i];
        if (cat.schedules.length > 0) {
            finalData.push(cat);
        }
    }
    return finalData;
}

export function getAllCategoryIds (catArr) {
    let ids = [];
    for (let i = 0; i < catArr.length; i++) {
        const m = catArr[i];
        ids.push(m.id);
        ids.push(...m.categoryIds);
    }
    ids = removeDuplicateStrings(ids);
    return ids;
}

export function getSchedulesForCatIds (catIds, schedulesSources) {
    const scheds = [];
    for (let i = 0; i < schedulesSources.length; i++) {
        const sched = schedulesSources[i];
        const included = arrayIncludes(sched.categoryIds, catIds);
        if (included) {
            scheds.push(sched);
        }
    }
    return scheds;
}

export default getSchedules;